import React from 'react';
import useConnectToPrivateMeetingMethod, { ConnectionPrivateDetailsType } from '../../hooks/use-connect-to-private-meeting-method';
import Button from '../../components/button';
import Icon from '../../components/_base/Icon';
import useConnectToPublicMeetingMethod, { ConnectionPublicDetailsType } from '../../hooks/use-connect-to-public-meeting-method';
import { PrivateMeetingDetailsResponseType, PublicMeetingDetailsResponseType } from '../../lib/api';
import { getKvThumbnailUrl } from '../../lib/api/utils';
import { PREVENTED_DETAILS_TEXT } from './MeetingDetails';
import { Connection } from '../../lib/connection/connection';

export type JoinButtonProps = {
  isDisabled: boolean;
  meetingDetails: PrivateMeetingDetailsResponseType | PublicMeetingDetailsResponseType | void;
  useConnectToMeetingMethod: typeof useConnectToPrivateMeetingMethod | typeof useConnectToPublicMeetingMethod;
  className?: string;
  joinUrl?: string | null;
}

type ConnectionDetailsType = ConnectionPrivateDetailsType & ConnectionPublicDetailsType

export const ThumbnailJoinButton: React.FunctionComponent<JoinButtonProps> = (props): JSX.Element | null => {
  const { meetingDetails, useConnectToMeetingMethod } = props;
  const connectToMeeting = useConnectToMeetingMethod(meetingDetails as ConnectionDetailsType);

  if (!meetingDetails) return null;

  const connection = Connection.create(meetingDetails) as Connection;

  return (
    <Button.Thumbnail
      className={'bg-transparent'}
      name='join'
      onClick={connectToMeeting}
    >
      <img
        className='h-full w-full object-contain'
        alt='knovio thumbnail'
        src={getKvThumbnailUrl(connection.embedCodeId)}
      />
    </Button.Thumbnail>
  );
};


export const JoinButton: React.FC<JoinButtonProps> = (props: JoinButtonProps): JSX.Element | null => {
  const { isDisabled, meetingDetails, useConnectToMeetingMethod, className, joinUrl } = props;
  const connectDetails = isDisabled ? undefined : { ...props.meetingDetails, joinUrl };
  const connectToMeeting = useConnectToMeetingMethod(connectDetails as ConnectionDetailsType);
  if (!meetingDetails) return null;

  const connection = Connection.create(meetingDetails);

  return (
    <>
      <Button.Common
        name='join'
        disabled={isDisabled || (!connection && !joinUrl)}
        onClick={connectToMeeting}
        label='Connect to Meeting'
        data-meeting-id={meetingDetails.meetingId}
        className={className}
      >
        <Icon.RightArrow className='fill-current text-white mb-1 ml-2' height='15px' width='15px'/>
      </Button.Common>
      {( isDisabled || (!connection && !joinUrl)) && <div className='join-button__connection-details  font-size-14px pt-4 whitespace-pre-wrap leading-loose'>
        <div className='connection-details-title font-semibold'>Connection Details</div>
        <div>{PREVENTED_DETAILS_TEXT}</div>
      </div>
      }
    </>
  );
};

export default (props: JoinButtonProps): JSX.Element | null => {
  if (!props.meetingDetails) return null;

  const connection = Connection.create(props.meetingDetails);

  return connection && connection.isKnovioConnectionType() && !props.isDisabled
    ? <ThumbnailJoinButton {...props} />
    : <JoinButton {...props} />
  ;
};
